module.exports = __webpack_public_path__ + "static/img/5983_phase_function_Paper_Points.f0010d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5983_phase_function_Paper_Points.png
// module id = FX5i
// module chunks = 0